module.exports = __webpack_public_path__ + "static/media/b24@2x.f5700269.png";